import {
    ICubeSourceHierarchyPolicy,
    ICubeSourcePolicyHierarchyProperties,
    IDimensionPolicyOptions
} from "../../PA.HyperRectangle.Core/CubeSource.IF";
import {PAdbContext} from "../../PA.Core/PAdbContext";
import {DimensionType} from "../../PA.Core/PA.Core.IF.Hierarchy";
import * as _ from "lodash"
import {WB_PeriodRow} from "../../PA.Core/PAdbSchemaRows";
import {esWB_Period} from "../../PA.Core/PAdbSchema";

export class DefaultHierarchyPolicy
    implements
        ICubeSourceHierarchyPolicy {
    private dbContext: PAdbContext

    constructor() {
        this.dbContext = new PAdbContext()
    }

    get PolicyId(): string {
        return "Default"
    }

    async getHierarchyProperties(dimType: DimensionType,
                                 options: IDimensionPolicyOptions): Promise<ICubeSourcePolicyHierarchyProperties>
    {
        if(_.isEmpty(options))
            return undefined

        let effectiveStartDt: Date = options.EffectiveStartDt
        let effectiveEndDt: Date = options.EffectiveEndDt
        if(!_.isDate(effectiveStartDt) || !_.isDate(effectiveEndDt)){
            if(_.isNumber(options.WB_PERIOD_ID)){
                let arrPeriods: WB_PeriodRow[] = <any> await this.dbContext.findUsingCache(esWB_Period, [options.WB_PERIOD_ID])
                let period = _.first(arrPeriods)
                if(!_.isEmpty(period)){
                    effectiveStartDt = period.PeriodStartDt
                    effectiveEndDt = period.PeriodEndDt
                }
            }
        }


        switch(dimType){
            case DimensionType.Customer:
                return {
                    HierarchyId: options.WB_CUSTH_ID |options.WB_CustomerHierarchyRow?.cif?.WB_CUSTH_ID,
                    LeafLevel: options.Customer_Level,
                    EffectiveStartDt: effectiveStartDt,
                    EffectiveEndDt: effectiveEndDt
                }
                break;

            case DimensionType.Product:
                return {
                    HierarchyId: options.WB_PRDH_ID |options.WB_ProductHierarchyRow?.cif?.WB_PRDH_ID,
                    LeafLevel: options.Product_Level,
                    EffectiveStartDt: effectiveStartDt,
                    EffectiveEndDt: effectiveEndDt
                }
                break;

            case DimensionType.Time:
                return {
                    HierarchyId: options.WB_PERIODH_ID |options.WB_PeriodHierarchyRow?.cif?.WB_PERIODH_ID,
                    LeafLevel: options.Period_Level,
                    EffectiveStartDt: effectiveStartDt,
                    EffectiveEndDt: effectiveEndDt
                }
                break;
        }

        return undefined
    }
}